
import React, { Component } from 'react';
import { Box } from 'reactjs-admin-lte'
import { Pagination, Form, FormGroup, Button } from 'react-bootstrap'
// import { momentHelper } from '../helpers'
// import SelectDate from 'component/element/SelectDate'
// import Select from 'react-select'
import PrintButtons from 'component/element/PrintButtons'
import ReportStore from 'stores/ReportStore'
import XLSX from 'xlsx'
import FileSaver from 'file-saver'
import FontAwesome from 'react-fontawesome'
// import DatePicker from 'component/element/DatePicker'
import IframeModal from 'component/element/IframeModal'

import '../report.css'
// import { connect } from 'react-redux';

class ReportUnfinishedWork extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading:false,
      activePage:1,
      data:[],
      payment_type:'',
      start_day:'',
      end_day:'',
      showDetail:false,
      isSubMenu:false,
      subMenu:[]
    }
    this.refTableId = 'ReportUnfinishedWork-'+Math.ceil(Math.random()*100);
    this.refTableDetailId = 'ReportUnfinishedWorkDetail-'+Math.ceil(Math.random()*100);
  }

  componentDidMount(){
   
  }

  componentWillReceiveProps(newProps){
    if(newProps.show && newProps.show!==this.props.show){
      this.loadData()
    }
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  getDetailSummary(field) {
    let {dataDetail} = this.state
    let total = 0
    dataDetail.forEach((item,index)=> {
      total += (item[field]===''||item[field]===null||item[field]===undefined||isNaN(item[field])?0:item[field]*1)
    }) 
    return total
  }

  loadData() {
    this.setState({loading:true})
    ReportStore.loadUncompletedWork((result)=>{
      this.setState({loading:false,data:result.data})
    })
  }

  onTableDetailCloseClick() {
    this.setState({subMenu:[],isSubMenu:false,payment_type:'',start_day:'',end_day:'',showDetail:false,dataDetail:[]},()=>{
      if (this.props.onUpdateEventKey!=undefined)
        this.props.onUpdateEventKey(undefined)
    })
  }

  onRowClick(item,start_day,end_day) {
    let to = ''
    if (start_day==91&&end_day==0)
      to = start_day+' วัน'
    else if (start_day!=0&&end_day!=0)
      to = start_day+' - '+end_day+' วัน'
    
    this.setState({loading:true,payment_type:item.payment_type,start_day:start_day,end_day:end_day,subMenu:[{title:'ประเภท '+(item.payment_type=='CASH'?'เงินสด':item.payment_type=='INSURER'?'ประกัน':'ยอดรวม')+' '+to,key:'s'+0}],isSubMenu:true},()=>{
        if (this.props.onUpdateEventKey!=undefined)
            this.props.onUpdateEventKey('s'+0)
    })
    ReportStore.loadUncompletedWorkDetail(item.payment_type,start_day,end_day,(result)=>{
        this.setState({loading:false,dataDetail:result.data,showDetail:true})
    })
  }

  renderBody() {
    let {data} = this.state
    if (data.length===0) {
      return(<tr><td colSpan={11}>ไม่พบข้อมูล</td></tr>)
    } else {
      return(
        data.map((item,index)=>
            <tr key={index}>
              <td className='text-center'>{item.title}</td>
              <td className='text-right' style={{backgroundColor:'#d5edf8'}}>{item.day30_count}</td>
              <td className='text-right' style={{backgroundColor:'#d5edf8'}}><Button onClick={this.onRowClick.bind(this,item,1,9)} bsClass='default' bsSize='xs'><FontAwesome name='search' /></Button> {this.getNumberFormat(item.day30_amount)}</td>
              <td className='text-right' style={{backgroundColor:'#daf2d7'}}>{this.getNumberFormat(item.day60_count)}</td>
              <td className='text-right' style={{backgroundColor:'#daf2d7'}}><Button onClick={this.onRowClick.bind(this,item,31,60)} bsClass='default' bsSize='xs'><FontAwesome name='search' /></Button> {this.getNumberFormat(item.day60_amount)}</td>
              <td className='text-right' style={{backgroundColor:'#fcfae1'}}>{this.getNumberFormat(item.day90_count)}</td>
              <td className='text-right' style={{backgroundColor:'#fcfae1'}}><Button onClick={this.onRowClick.bind(this,item,61,90)} bsClass='default' bsSize='xs'><FontAwesome name='search' /></Button> {this.getNumberFormat(item.day90_amount)}</td>
              <td className='text-right' style={{backgroundColor:'#f5dddd'}}>{this.getNumberFormat(item.day91_count)}</td>
              <td className='text-right' style={{backgroundColor:'#f5dddd'}}><Button onClick={this.onRowClick.bind(this,item,91,0)} bsClass='default' bsSize='xs'><FontAwesome name='search' /></Button> {this.getNumberFormat(item.day91_amount)}</td>
              <td className='text-right'>{this.getNumberFormat(item.all_count)}</td>
              <td className='text-right'><Button onClick={this.onRowClick.bind(this,item,0,0)} bsClass='default' bsSize='xs'><FontAwesome name='search' /></Button> {this.getNumberFormat(item.all_amount)}</td>
            </tr>
        )
      )
    }
  }

  renderBodyDetail() {
    let {dataDetail} = this.state
    if (dataDetail.length===0) {
      return(<tr><td colSpan={8}>ไม่พบข้อมูล</td></tr>)
    } else {
        return(
            dataDetail.map((item,index)=>{
                return(
                    <tr key={index}>
                        <td className='text-center'>{index+1}</td>
                        <td className='text-center'>{item.work_no}</td>
                        <td className='text-center'>{item.work_date}</td>
                        <td className='text-left'>{item.owner_name}</td>
                        <td className='text-center'>{item.car_registration_no}</td>                        
                        <td className='text-center'>{item.brand}</td>
                        <td className='text-center'>{item.model}</td>
                        <td className='text-right'>{this.getNumberFormat(item.amount)}</td>
                    </tr>
                )
            })
        )    
    }
  }

  renderTable() {
    return (
      <div className='display-overflow'>
        <table id={this.refTableId} className='table table-responsive table-hover table-bordered table-report-kkc-income' style={{minWidth:'1200px'}}>
          <thead>
            <tr>
              <th className='text-center' style={{width:'100px'}}>ชำระเงิน<br/>ประเภท</th>
              <th className='text-center' style={{width:'120px',backgroundColor:'#d5edf8'}}>1-30 วัน</th>
              <th className='text-center' style={{width:'200px',backgroundColor:'#d5edf8'}}>จำนวนเงิน</th>
              <th className='text-center' style={{width:'120px',backgroundColor:'#daf2d7'}}>31-60 วัน</th>
              <th className='text-center' style={{width:'200px',backgroundColor:'#daf2d7'}}>จำนวนเงิน</th>
              <th className='text-center' style={{width:'120px',backgroundColor:'#fcfae1'}}>61-90 วัน</th>
              <th className='text-center' style={{width:'200px',backgroundColor:'#fcfae1'}}>จำนวนเงิน</th>
              <th className='text-center' style={{width:'120px',backgroundColor:'#f5dddd'}}>91 วันขึ้นไป</th>
              <th className='text-center' style={{width:'200px',backgroundColor:'#f5dddd'}}>จำนวนเงิน</th>
              <th className='text-center' style={{width:'120px'}}>รวมทั้งสิ้น</th>
              <th className='text-center' style={{width:'200px'}}>จำนวนเงิน</th>
            </tr>
          </thead>
          <tbody>
            {this.renderBody()}
          </tbody>
        </table>
      </div>
    )
  }

  renderTableDetail() {
    let to = ''
    if (this.state.start_day==91&&this.state.end_day==0)
      to = this.state.start_day+' วัน'
    else if (this.state.start_day!=0&&this.state.end_day!=0)
      to = this.state.start_day+' - '+this.state.end_day+' วัน'
    
    return (
        <div className='display-overflow'>
          <table id={this.refTableDetailId} className='table table-responsive table-hover table-bordered-solid table-report-kkc-income'>
            <thead>
              <tr style={{display:'none'}}>
                <th colSpan={3}>ประเภท : {this.state.payment_type}</th>
                <th colSpan={5}>{to}</th>
              </tr>  
              <tr>
                <th className='text-center' style={{width:'50px'}}>ลำดับ</th>
                <th className='text-center' style={{width:'100px'}}>หมายเลขใบงาน</th>
                <th className='text-center' style={{width:'120px'}}>วันที่</th>
                <th className='text-center' style={{width:'200px'}}>เจ้าของ</th>
                <th className='text-center' style={{width:'120px'}}>เลขทะเบียน</th>
                <th className='text-center' style={{width:'100px'}}>ยี่ห้อ</th>
                <th className='text-center' style={{width:'100px'}}>รุ่น</th>
                <th className='text-center' style={{width:'100px'}}>มูลค่า</th>
              </tr>
            </thead>
            <tbody>
              {this.renderBodyDetail()}
            </tbody>
            <tfoot>
              <tr>
                <th colSpan={7} className='text-right'>ยอดรวมสุทธิ</th>
                <th className='text-right'>{this.getNumberFormat(this.getDetailSummary('amount'))}</th>
              </tr>
            </tfoot>
          </table>
        </div>
    )
  }

  onPageSelect(eventKey) {
    this.setState({
      activePage: eventKey
    })
    // next... load new page
  }

  onExportExcel(e) {
    const worksheet = XLSX.utils.table_to_book(document.getElementById(this.refTableId));
    let wbout = XLSX.write(worksheet, { bookType: 'xlsx', bookSST: true, type: 'binary' });

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }    
    const fileName = 'รายงานสรุปงานซ่อมค้างปิด.xlsx'
    FileSaver.saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), fileName) 
    this.setState({showExport:false})
  }

  onPrintTable(e) {
    let url = ''
    let param = 'PrintReportUnfinishedWork'

    if (process.env.NODE_ENV == "development") {
      url  = './?startPage='+param
    } else{
      url = './pdf/v2/?startPage='+param
    }
    this.refs.iframe.loadUrl(url)
  }

  onExportExcelDetail(e) {
    const worksheet = XLSX.utils.table_to_book(document.getElementById(this.refTableDetailId));
    let wbout = XLSX.write(worksheet, { bookType: 'xlsx', bookSST: true, type: 'binary' });

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }    
    let fileName = 'รายงานสรุปงานซ่อมค้างปิด ประเภท '+(this.state.payment_type=='CASH'?'เงินสด':this.state.payment_type=='INSURER'?'ประกัน':'ยอดรวม')
    if (this.state.start_day==91&&this.state.end_day==0)
      fileName += ' '+this.state.start_day+' วัน.xlsx'
    else if (this.state.start_day!=0&&this.state.end_day!=0)
      fileName += ' '+this.state.start_day+' - '+this.state.end_day+' วัน.xlsx'
    else
      fileName += '.xlsx'

    FileSaver.saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), fileName)
    this.setState({showExport:false})
  }

  onPrintTableDetail(e) {
    let url = ''
    let param = 'PrintReportUnfinishedWorkDetail&paymentType='+this.state.payment_type+'&startDay='+this.state.start_day+'&endDay='+this.state.end_day
    if (process.env.NODE_ENV == "development") {
      url  = './?startPage='+param
    } else{
      url = './pdf/v2/?startPage='+param
    }
    this.refs.iframe.loadUrl(url)
  }

  renderToolbar() {
    return(
      <Form inline>
        <FormGroup style={{verticalAlign:'top',marginTop:'1.5px',marginBottom:'5px'}}>
          <PrintButtons
            onPrintTable={this.onPrintTable.bind(this)}
            onExportExcel={this.onExportExcel.bind(this)}
            marginLeft='0'
            width='auto'
          />
        </FormGroup>
      </Form>
    )
  }

  renderToolbarDetail() {
    return(
        <Form inline>
            <FormGroup style={{verticalAlign:'top',marginTop:'1.5px',marginBottom:'5px'}}>
                <PrintButtons
                    onPrintTable={this.onPrintTableDetail.bind(this)}
                    onExportExcel={this.onExportExcelDetail.bind(this)}
                    marginLeft='0'
                    width='auto'
                />
            </FormGroup>
        </Form>
    )    
  }

  renderPaging() {
    return (
      <div className="text-center pull-right">
        <Pagination
          prev
          next
          first
          last
          bsSize="medium"
          items={5}
          activePage={this.state.activePage}
          onSelect={this.onPageSelect.bind(this)} />
      </div>
    )
  }

  render() {
    const reportName = 'รายงานสรุปงานซ่อมค้างปิด'
    const title = reportName
    const {loading,showDetail} = this.state
    return (
      <Box loading={loading}>
        <Box.Header border={true}>          
          {this.props.renderMenu(this.state.isSubMenu,this.state.subMenu)}
        </Box.Header>
        <Box.Body>
          {showDetail?this.renderToolbarDetail():this.renderToolbar()}
          {showDetail?this.renderTableDetail():this.renderTable()}
          {/*this.renderPaging()*/}
          <IframeModal ref='iframe' title={'พิมพ์เอกสาร'} />
        </Box.Body>
        {showDetail?
        <Box.Footer>
            <div className=" pull-right">
                <Button bsStyle='default' onClick={this.onTableDetailCloseClick.bind(this)}><FontAwesome name='table' />&nbsp;กลับหน้าตารางหลัก</Button>    
            </div>
        </Box.Footer>
        :''}
      </Box>
    )
  }
}

ReportUnfinishedWork.defaultProps = {
  show : false
}

export default ReportUnfinishedWork;





// WEBPACK FOOTER //
// ./src/view/report/fixing/ReportUnfinishedWork.js